export const ReservationTypeForSearchReservationList = {
	cInDate: "cInDate",
	cOutDate: "cOutDate",
	stayDate: "stayDate",
	dayTripCInDate: "dayTripCInDate",
} as const;

export type ReservationTypeForSearchReservationList =
	(typeof ReservationTypeForSearchReservationList)[keyof typeof ReservationTypeForSearchReservationList];
